import { useQuery } from 'react-query';
import { IPaginationParams } from 'services/types';
import { getUserId } from 'services/DefaultService';
import { ICommunicationFilterParams } from '../../types';
import {
  getAllCommunicationsByLicenseAsync,
  getAllCommunicationsByLicenseCountAsync,
} from '../../index';

const USER_ID = getUserId();

export const useGetAllCommunicationsByLicenseAsync = (
  pagination: IPaginationParams,
  filter: ICommunicationFilterParams,
) =>
  useQuery([`Communication${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllCommunicationsByLicenseAsync(pagination, filter),
  });

export const useGetAllCommunicationsByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: ICommunicationFilterParams,
) =>
  useQuery(
    [`CommunicationCount${pagination.pageNumber}`, pagination, USER_ID],
    {
      keepPreviousData: true,
      staleTime: 1000 * 60,
      queryFn: () => getAllCommunicationsByLicenseCountAsync(filter),
    },
  );
